module.exports = __webpack_public_path__ + "media/images/hero_images/security-3000-f8d9cd8ab05d68e0a91658e3dcd58d79.png";